// removed by extract-text-webpack-plugin
module.exports = {"container":"nktaJ"};


//////////////////
// WEBPACK FOOTER
// ./app/components/card-overlay/card-overlay.scss
// module id = 1719
// module chunks = 0